module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2318860.3756d414.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2318860.pdf
// module id = 846
// module chunks = 0